export function getProjectionDotColor(projectedVal, minStock, maxStock) {
  if (projectedVal > maxStock) return "#bc6bd9"; // Overstock
  else if (projectedVal <= maxStock && projectedVal >= minStock) return "#27ae60"; // On track
  else if (projectedVal < minStock && projectedVal > 0) return "#f79900"; // Low stock
  else if (projectedVal <= 0) return "#f40000"; // Stockout
  else return "#000"; // Neutral/fallback
}

export const exceptionColorMap = {
    "stockout": "#f40000",
    "batch expired": "#ff560e",
    "overstock": "#bc6bd9",
    "low stock": "#f79900",
    "batch expiring": "#e5813e",
    "on track": "#268000",
    "no exception": "#000"
  };